export default __webpack_public_path__ + "static/media/zayed-project-1.3ef99fa4.webp";